export default __webpack_public_path__ + "static/media/a037-passportNumber-07.0f6dfb5f.png";